export enum FormFieldKeyActionEnum {
    Licence = 1,
    Insurance = 2,
    Priority = 3,
    Fee = 4,
    ApplicationDate = 5,
    UserCredit = 6
}
